import { Injectable } from '@angular/core';
import { Conversation } from '@elevenlabs/client';
import { ElevenLabsVoiceService } from './elevenlabs-voice.service';

@Injectable({ providedIn: 'root' })
export class ElevenLabsAgentService {
    private conversation: any;
    private conversationId = '';

    constructor(private voice: ElevenLabsVoiceService) {}

    async start(onMode: (mode: string) => void, onError: () => void, onMessage: (message: string, source: 'user' | 'ai', conversationId: string) => void): Promise<void> {
        try {
            await this.stop();
            const signedUrl = await this.voice.createAgentSignedUrl();
            if (!signedUrl) throw new Error('Missing ElevenLabs agent signed URL');
            this.conversation = await Conversation.startSession({
                signedUrl,
                onConnect: ({ conversationId }) => { this.conversationId = conversationId; },
                onModeChange: ({ mode }) => onMode(mode),
                onError: () => onError(),
                onMessage: ({ message, source }) => onMessage(message, source, this.conversationId),
                onDisconnect: () => { this.conversation = undefined; this.conversationId = ''; },
            });
        } catch (error) {
            console.error('[ElevenLabs agent] Session start failed', error);
            throw error;
        }
    }

    async stop(): Promise<void> {
        if (this.conversation) await this.conversation.endSession();
        this.conversation = undefined;
        this.conversationId = '';
    }
}
